module.exports = __webpack_public_path__ + "img/5.2b1f0576.png";